import React from 'react';
import ScorecardTabsComponent from 'src/components/scorecard/ScorecardTabsComponent';
import QuestionsContainerTitleBar from './QuestionsContainerTitleBar';
import QuestionContainer from './QuestionContainer';
import { MeetingDetails, Question, RoundType } from 'types';
import { useUserContext } from 'src/context/UserProvider';

interface Props {
	tab: {
		index: number;
		roundType: RoundType;
	};
	setTab: (arg: { index: number; roundType: RoundType }) => void;
	selectedRoundMeetingDetails: MeetingDetails | undefined;
	questionsData: {
		question: Question;
		score: number;
		timeTaken: number;
		questionType: RoundType;
		assessedSkills: { _id: string; name: string; isSoftSkill: boolean }[];
	}[];
}

const TechRoundQuestionsContainer = ({ tab, setTab, selectedRoundMeetingDetails, questionsData }: Props) => {
	const { isAccountManagerLoggedIn, isRecruiterLoggedIn } = useUserContext();

	const generateTabsConfigFromRoundData = (details: MeetingDetails | undefined) => {
		if (details) {
			if (details?.roundData?.length) {
				return details.roundData.map(d => ({
					tabScore: Number(d.score?.toFixed(2) || 0),
					key: d.roundType,
				}));
			}
		}

		return [];
	};

	const showScorecardTabsComponent = !!selectedRoundMeetingDetails?.roundData?.length;

	return (
		<>
			<div>
				<div className="text-sm font-medium text-[#004FC4] dark:text-[#E5FFFF]">Tech round questions asked</div>

				<hr className="mt-2 border-[#E4E4EB] dark:border-[#303A47]" />

				{showScorecardTabsComponent ? (
					<div className="mt-3 overflow-x-auto">
						{/* {isAccountManagerLoggedIn || isRecruiterLoggedIn ? (
							<ScorecardTabsComponent
								tab={tab}
								setTab={setTab}
								tabsConfig={generateTabsConfigFromRoundData(selectedRoundMeetingDetails)}
							/>
						) : null} */}

						{questionsData.length ? (
							<div className="mt-3 bg-white dark:bg-inherit rounded-xl overflow-hidden">
								<QuestionsContainerTitleBar />

								<div className="">
									{questionsData.map((q, i) => (
										<React.Fragment key={q.question._id}>
											<QuestionContainer index={i} questionData={q} />
										</React.Fragment>
									))}

									<div className="text-sm font-light italic text-[#555770] dark:text-[#FFFEE5] my-2 md:hidden px-2">
										<span className="font-bold">Note:</span> Questions details viewable on desktop only
									</div>
								</div>
							</div>
						) : null}
					</div>
				) : (
					<div className="text-[#555770] dark:text-[#FFFEE5] text-sm font-light italic mt-3">
						No questions available
					</div>
				)}
			</div>
		</>
	);
};

export default TechRoundQuestionsContainer;
